const writingAssistantCompletionMode = ({
  hostTextReturnRequested,
  hostTextReturnSupported
}) => (
  hostTextReturnRequested === true && hostTextReturnSupported === true
    ? 'apply'
    : 'copy'
)

export { writingAssistantCompletionMode }
